module.exports = __webpack_public_path__ + "img/sign-18.70fd061d.jpg";